module.exports = __webpack_public_path__ + "img/39.ed0aab4e.png";